(() => {
  try { if (!window.Shopify?.customerPrivacy) window.Shopify?.loadFeatures?.([{name: 'consent-tracking-api', version: '0.1'}], () => {}); } catch {}
  const key = 'veiro:favorites:v1';
  let ids = new Set();
  try { const stored = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(stored)) ids = new Set(stored.filter(x => typeof x === 'string')); } catch {}
  const buttons = () => [...document.querySelectorAll('[data-veiro-favorite]')];
  const draw = () => buttons().forEach(button => {
    const selected = ids.has(button.dataset.veiroFavorite);
    button.setAttribute('aria-pressed', String(selected));
    button.setAttribute('aria-label', selected ? 'お気に入りから外す' : 'お気に入りに追加');
  });
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-veiro-favorite]');
    if (!button) return;
    event.preventDefault();
    event.stopPropagation();
    const id = button.dataset.veiroFavorite;
    if (!id) return;
    const added = !ids.has(id);
    added ? ids.add(id) : ids.delete(id);
    try { localStorage.setItem(key, JSON.stringify([...ids])); } catch {}
    draw();
    try {
      if (window.Shopify?.customerPrivacy?.analyticsProcessingAllowed?.() === true) {
        const result = window.Shopify?.analytics?.publish?.('veiro:favorite_changed', {
          action: added ? 'add' : 'remove', item_id: id,
          item_name: button.dataset.productTitle || '',
          item_variant: button.dataset.productColor || '',
          currency: 'JPY'
        });
        if (result?.catch) result.catch(() => {});
      }
    } catch {}
  });
  window.addEventListener('storage', event => {
    if (event.key !== key && event.key !== null) return;
    try { const next = JSON.parse(event.newValue || '[]'); if (Array.isArray(next)) ids = new Set(next.filter(x => typeof x === 'string')); } catch { return; }
    draw();
  });
  draw();
})();
